import { apiFetch } from "./index";

const API_BASE = "/DevolucionHerramienta";

export const obtenerDevolucionesHerramienta = async () => {
    try {
        const response = await apiFetch(API_BASE);
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message || "Error al obtener devoluciones" };
    }
};

export const obtenerDevolucionHerramienta = async (id) => {
    try {
        const response = await apiFetch(`${API_BASE}/${id}`);
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message || "Error al obtener devolución" };
    }
};

export const obtenerDevolucionesPorSalida = async (idSalida) => {
    try {
        const response = await apiFetch(`${API_BASE}/salida/${idSalida}`);
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message || "Error al obtener devoluciones por salida" };
    }
};

export const crearDevolucionHerramienta = async (data) => {
    try {
        const response = await apiFetch(API_BASE, {
            method: "POST",
            body: data
        });
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message || "Error al crear devolución" };
    }
};

export const actualizarDevolucionHerramienta = async (id, data) => {
    try {
        const response = await apiFetch(`${API_BASE}/${id}`, {
            method: "PUT",
            body: data
        });
        return { success: true, data: response };
    } catch (error) {
        return { success: false, error: error.message || "Error al actualizar devolución" };
    }
};

export const eliminarDevolucionHerramienta = async (id) => {
    try {
        await apiFetch(`${API_BASE}/${id}`, {
            method: "DELETE"
        });
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message || "Error al eliminar devolución" };
    }
};
